export default __webpack_public_path__ + "static/media/gallery_14.4edc9c18.jpg";